var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "form-generator-container" },
    [
      _vm.showRequiredFieldsAdvice
        ? _c("span", { staticClass: "required-fields-advice" }, [
            _vm._v(_vm._s(_vm.$t("components.form_generator.required_fields"))),
          ])
        : _vm._e(),
      _c("ValidationObserver", {
        ref: _vm.formTag,
        staticClass: "form",
        attrs: { tag: "div", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.mainAction.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ validate }) {
              return [
                _vm._l(_vm.parseSchema, function (field, index) {
                  return [
                    field.fieldType === "LexonHiddenComponent"
                      ? [
                          _c(
                            field.fieldType,
                            _vm._b(
                              {
                                tag: "component",
                                staticClass: "form-element",
                                attrs: { value: _vm.getFieldValue(field) },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateForm(field, $event)
                                  },
                                },
                              },
                              "component",
                              field,
                              false
                            )
                          ),
                        ]
                      : [
                          field.fieldset
                            ? _c(
                                "v-col",
                                {
                                  class: ["d-inline-block", "pa-0", "form-row"],
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "fieldset",
                                    {
                                      class: [
                                        {
                                          "md-and-up":
                                            _vm.$vuetify.breakpoint.mdAndUp,
                                        },
                                        "fieldset",
                                      ],
                                    },
                                    [
                                      _vm.getFieldSetName(field)
                                        ? _c(
                                            "legend",
                                            { staticClass: "fieldset-legend" },
                                            [_vm._v(_vm._s(field.fieldsetName))]
                                          )
                                        : _vm._e(),
                                      _vm._l(
                                        field.fields,
                                        function (field, index) {
                                          return _c(
                                            "v-col",
                                            {
                                              key: index,
                                              class: [
                                                _vm.calculatePaddingWidth,
                                                "d-inline-block",
                                                {
                                                  "hidden-field": field.hidden,
                                                },
                                                "form-row",
                                              ],
                                              attrs: {
                                                cols: _vm.setBreakpoint(
                                                  field,
                                                  _vm.breakpoints.xs,
                                                  _vm.breakpointsClosedMenu.xs
                                                ),
                                                sm: _vm.setBreakpoint(
                                                  field,
                                                  _vm.breakpoints.sm,
                                                  _vm.breakpointsClosedMenu.sm
                                                ),
                                                md: _vm.setBreakpoint(
                                                  field,
                                                  _vm.breakpoints.md,
                                                  _vm.breakpointsClosedMenu.md
                                                ),
                                                lg: _vm.setBreakpoint(
                                                  field,
                                                  _vm.breakpoints.lg,
                                                  _vm.breakpointsClosedMenu.lg
                                                ),
                                                xl: _vm.setBreakpoint(
                                                  field,
                                                  _vm.breakpoints.xl,
                                                  _vm.breakpointsClosedMenu.xl
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                field.fieldType,
                                                _vm._b(
                                                  {
                                                    ref: "formComponent",
                                                    refInFor: true,
                                                    tag: "component",
                                                    staticClass: "form-element",
                                                    attrs: {
                                                      value:
                                                        _vm.getFieldValue(
                                                          field
                                                        ),
                                                      context: _vm.context,
                                                      text: field.buttonText
                                                        ? field.buttonText
                                                        : null,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.updateForm(
                                                          field,
                                                          $event
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.emitOnBlurEvent(
                                                          field,
                                                          $event
                                                        )
                                                      },
                                                      "execute-action":
                                                        _vm.executeAction,
                                                      lexonButtonEvent:
                                                        _vm.lexonButtonEvent,
                                                    },
                                                  },
                                                  "component",
                                                  field,
                                                  false
                                                )
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _c(
                                "v-col",
                                {
                                  class: [
                                    { "full-width": field.fullWidth },
                                    _vm.calculatePaddingWidth,
                                    "d-inline-block",
                                    "form-row",
                                    { "hidden-field": field.hidden },
                                  ],
                                  attrs: {
                                    cols: _vm.setBreakpoint(
                                      field,
                                      _vm.breakpoints.xs,
                                      _vm.breakpointsClosedMenu.xs
                                    ),
                                    sm: _vm.setBreakpoint(
                                      field,
                                      _vm.breakpoints.sm,
                                      _vm.breakpointsClosedMenu.sm
                                    ),
                                    md: _vm.setBreakpoint(
                                      field,
                                      _vm.breakpoints.md,
                                      _vm.breakpointsClosedMenu.md
                                    ),
                                    lg: _vm.setBreakpoint(
                                      field,
                                      _vm.breakpoints.lg,
                                      _vm.breakpointsClosedMenu.lg
                                    ),
                                    xl: _vm.setBreakpoint(
                                      field,
                                      _vm.breakpoints.xl,
                                      _vm.breakpointsClosedMenu.xl
                                    ),
                                  },
                                },
                                [
                                  _vm.appendElementId === field.id
                                    ? _vm._t("appendElement")
                                    : _vm._e(),
                                  _c(
                                    field.fieldType,
                                    _vm._b(
                                      {
                                        ref: "formComponent",
                                        refInFor: true,
                                        tag: "component",
                                        staticClass: "form-element",
                                        attrs: {
                                          value: _vm.getFieldValue(field),
                                          context: _vm.context,
                                          text: field.buttonText
                                            ? field.buttonText
                                            : null,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.updateForm(field, $event)
                                          },
                                          blur: function ($event) {
                                            return _vm.emitOnBlurEvent(
                                              field,
                                              $event
                                            )
                                          },
                                          "execute-action": _vm.executeAction,
                                          lexonButtonEvent:
                                            _vm.lexonButtonEvent,
                                        },
                                      },
                                      "component",
                                      field,
                                      false
                                    )
                                  ),
                                ],
                                2
                              ),
                        ],
                  ]
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }